import axios from 'axios'
import { useAuthHeader, useAuthUser } from 'react-auth-kit'
import { useState, useEffect } from 'react'
// import { Link } from 'react-router-dom'
// import AddButton from '../../usables/small/AddButton'
import Table from '../../usables/Table'
import Input from '../../usables/small/Input'
import Modal from '../../usables/Modal'
import Spinner from '../../usables/small/Spinner'
import ClosingAlert from '../../usables/Alert'
import Select from 'react-select'

export default function Classrooms() {
  const auth  = useAuthHeader()
  const authUser  = useAuthUser()
  const [classrooms, setClassrooms] = useState([])
  const [dataLoaded, setDataLoaded] = useState({done: false, sucssess: false, items: 0})
  const [subjectList, setSubjectList] = useState([])
  const [formData, setFormData] = useState({name: '', subject_id: ''})
  const [errorMsg, setErrorMsg] = useState('Nepavyko įrašyti reikšmės')
  const [showError, setShowError] = useState(false)

  const tableColumns = [{
    Header: "Kabinetai",
    columns: [
      {
        Header: "Numeris",
        accessor: "name"
      },
      {
        Header: "Dalykas",
        accessor: "subject[0].subject_name"
      },
      // {
      //   Header: "Veiksmai",
      //   accessor: "action"
      // },
    ]
  }]

  const config = {
    headers: {
      Authorization: auth()
    }
  }

  const createClassroom = () => {
    axios.post(process.env.REACT_APP_API + '/classroom', formData, config)
      .then((res)=>{
        if(res.status === 200){
          setClassrooms(classroom => [res.data.classroom, ...classroom ])
        }
      })
      .catch((err) => {
        setErrorMsg(err.response.data.message)
        setShowError(true)
      })
    }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API + '/classroom', config)
    .then(res => {
      if(res.status === 200){
        //console.log(...res.data)
        setClassrooms([]) //! Pašalinti prieš buildinant
        res.data.forEach((data) => {
          console.log(data)
          setClassrooms(classroom => [...classroom, data])
          setDataLoaded({done: true, sucssess: true, items: res.data.length})
        })
      }
    })
    .catch(err => {
      setClassrooms([]) //! Pašalinti prieš buildinant
      //console.log(err.response.data)
      setClassrooms(guardians => [...guardians, err.response.data])
      setDataLoaded({done: true, sucssess: false, items: 0})
    })

    axios.get(process.env.REACT_APP_API + '/subject', config)
      .then(res => {
        if(res.status === 200){
          setSubjectList([]) //! Pašalinti prieš buildinant
          res.data.forEach((data) => {
            setSubjectList(subjects => [...subjects, data])
          })
        }
      })
      .catch(err => {
        setSubjectList([]) //! Pašalinti prieš buildinant
        setSubjectList(subjects => [...subjects, err.response.data])
        // setDataLoaded({done: true, sucssess: false, items: 0})
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
    <h2>Kabinetai</h2>
    <ClosingAlert type='error' message={errorMsg} show={showError} updateState={(value) => {setShowError(value)}} />
      {!dataLoaded.done
      ? <Spinner />
      : dataLoaded.sucssess
        ?dataLoaded.items
          ? <Table columns={tableColumns} data={classrooms} />
          : <ClosingAlert type='warning' message='Kabinetų nerasta' />
        : <ClosingAlert type='error' message='Kažkas nepavyko, bendykite vėl šiek tiek vėliau' />
      }
    {authUser().roles.admin &&
    <Modal showAddBtn={true} title='Naujas kabinetas' saveText='Sukurti' submitFunction={() => {createClassroom()}}>
      <div className='pt-5'>
        <Input
          label='Numeris'
          name='name'
          type='text'
          value={formData.name}
          onChange={(e)=>setFormData({...formData, name: e.target.value})}
          />
        <div className='pt-0'>
          <label className='text-gray-500' htmlFor="class">Mokomasis dalykas</label>
          <Select
          name='class'
          onChange={(e)=>setFormData({...formData, subject_id: e.value})}
          options={
            subjectList.map(subject => {
              return ({ value: subject.id, label: subject.subject_name })
            })
          } />
          </div>
        </div>
      </Modal>
}
    </>
  )
}